// extracted by mini-css-extract-plugin
export default {"pageWrapper":"AppLoader_pageWrapper__c9-A6","container":"AppLoader_container__S2pTy","image":"AppLoader_image__t7Xn7"};